import { DOMAINS } from "../routes/domains";

// What's waiting for you in each section, on the nav (projects/discussions
// D14). Helpers shared by the header's menu button and the section links.

/** "99+" past two digits: the badge stays one size. */
export const badgeText = (n) => (n > 99 ? "99+" : String(n));

/** The sections with something waiting, as [{key, label, count}]. */
export function waitingIn(badges = {}) {
  return DOMAINS.filter((domain) => badges[domain.key] > 0).map((domain) => ({
    key: domain.key,
    label: domain.label,
    count: badges[domain.key],
  }));
}
